import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "@/store/StoreContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SearchOverlay } from "@/components/SearchOverlay";
import { WhatsAppFab } from "@/components/WhatsAppFab";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import CartPage from "@/pages/CartPage";
import Wishlist from "@/pages/Wishlist";
import CustomOrder from "@/pages/CustomOrder";
import InfoPage from "@/pages/InfoPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <StoreProvider>
        <ScrollToTop />
        <div className="flex min-h-screen flex-col bg-paper">
          <Header />
          <SearchOverlay />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/koleksi" element={<Shop />} />
              <Route path="/produk/:slug" element={<ProductDetail />} />
              <Route path="/keranjang" element={<CartPage />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/custom" element={<CustomOrder />} />
              <Route path="/:slug" element={<InfoPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <WhatsAppFab />
        <Toaster position="top-center" />
      </StoreProvider>
    </BrowserRouter>
  );
}

export default App;
